import React from 'react';

import { useHistory } from 'react-router-dom';
import { useDocument } from 'react-firebase-hooks/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';

import { zip } from 'utils/form';
import { ROUTE_WORKER_PREFIX } from 'utils/routes';

import Client from 'containers/app/client';
import ShiftsInfo from 'containers/worker/shifts-info/component';
import fields from 'containers/worker/shifts-info/fields';

import { LayoutPage, LayoutHorizontal } from 'components/layouts';
import LoadingFullPage from 'components/loading-full-page';

import './style.css';

const ShiftsInfoPage = () => {
  const history = useHistory();
  const [user, authLoading, authError] = useAuthState(Client.auth);
  const [values, valuesLoading, valuesError] = useDocument(Client.dbProfile());
  if (authError) throw authError;
  if (valuesError) throw valuesError;

  if (authLoading || valuesLoading) return <LoadingFullPage />;

  const onSubmit = async (vals, actions, handleValues) => {
    try {
      console.info('submitted', vals);
      await handleValues(vals);
      actions.setSubmitting(false);
      history.push(`${ROUTE_WORKER_PREFIX}/dashboard`);
    } catch (e) {
      console.error(e.title, e.errors);
      actions.setSubmitting(false);
    }
  };

  const onBack = async (vals, handleValues) => {
    try {
      console.info('saved', vals);
      await handleValues(vals);
      history.push(`${ROUTE_WORKER_PREFIX}/dashboard`);
    } catch (e) {
      console.error(e.title, e.errors);
    }
  };

  const initialValues = zip(fields, values.data());

  return (
    <LayoutPage className="shifts-info-page">
      <LayoutHorizontal className="shifts-info-page-container">
        <ShiftsInfo
          user={user}
          onSubmit={onSubmit}
          onBack={onBack}
          initialValues={initialValues}
        />
      </LayoutHorizontal>
    </LayoutPage>
  );
};

export default ShiftsInfoPage;
